// extracted by mini-css-extract-plugin
export default {"grid":"Offers-grid_aEKDL","more":"Offers-more_y1Eg2"};